/*
Sohel 01/10/2023 2699388043 Implemented Copy Functionality
Sohel 01/18/2023 2698951347 Fixed Payload Issue
Sohel 01/02/2023 2698951347 fixed code uppercase issue
Sohel 02/02/2023 2698951347 fixed copy payload issue
suresh peddavoora 02/27/2023 2698951347 textfields alignments fixes
Raghu 02/27/2023 2698951347 fixed ui alignments
sohel 03/06/2023 2698951347 Added validation message for existing value
Ravi 04/04/2023 2698951347 fixed double loader issue
Prakash 24/04/2023 2698951347 Fixed spaceing issue
Akhila 06/06/2023 2698951347 added code and description in action
Akhila 06/08/2023 2698951347 title label placeholder name change
Ravi 06/23/2023 2698951347 fixed submit issue
Sohel 11/12/2023 2698951347 code field and description field validation changes and case insenstive
Sohel 12/12/2023 2698951347 label name change code to name and validation changes
*/
import React, {useContext, useEffect, useRef} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import BreadCrums from '../../../../../util/BreadCrum';
import {
  fetchAllRecordCode,
  postCopyRecord,
} from '../../../../../redux/reducers/DataManagerRecord';
import {currsorCodeIssue} from '../../../../../components/UpperCaseCode';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
const CopyDataManagerRecord = ({oldDmrCodeData, type}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {
    allRecordCode,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const classes = reusableInputStyles();
  const codeRef = useRef();
  const dispatch = useDispatch();
  const initialValues = {
    code: '',
    description: '',
  };
  const typeName =
    type === 'Export' ? 'Export Template Record Name' : 'Import Template Record Name';
  const typeDesc =
    type === 'Export' ? 'Export Template Description' : 'Import Template Description';
  const checkCodeExist = (value) => {
    if (allRecordCode && allRecordCode?.length > 0 && value) {
      const ar = [];
      allRecordCode.filter((i) => {
        if (
          i?.recordCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkRecordCodeAlreadyExist = (value) => {
    if (allRecordCode && allRecordCode?.length > 0 && value) {
      const ar = [];
      allRecordCode.filter((i) => {
        if (
          i?.recordCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const schema = Yup.object().shape({
    code: Yup.string()
      .required(`${typeName} is required`)
      // .matches(codeRegex, codeValidationMessage)
      .test('code', `${typeName} already exist`, (value) => !checkCodeExist(value))
      .test(
        'code',
        `${typeName} has already been used in the past`,
        (value) => !checkRecordCodeAlreadyExist(value),
      ),

    description: Yup.string()
      .test('description', `${typeDesc} is required`, (value) => {
        return value?.replaceAll(' ', '');
      })
      .required(`${typeDesc} is required`),
  });
  const handleSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const data = {
        dmRecordCode: values?.code ? values?.code : '',
        dmRecordDescription: values?.description ? values?.description : '',
        oldDmRecordCode: oldDmrCodeData?.recordCode ? oldDmrCodeData?.recordCode : '',
        oldDataManagerRecordId: oldDmrCodeData?.dataManagerRecordId ? oldDmrCodeData?.dataManagerRecordId : 0,
        tabType: type,
        fileType: 'Record',
      };
      dispatch(postCopyRecord(data));
    }
  };
  useEffect(() => {
    dispatch(fetchAllRecordCode(type));
  }, []);
  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                touched,
                errors,
                resetForm,
                handleBlur,
                setFieldValue,
              } = props;
              return (
                <div>
                  <BreadCrums
                    // name={"Record Code"}
                    name={`${typeName}`}
                    code={oldDmrCodeData?.recordCode}
                    // description={"Record Description"}
                    description={`${typeDesc}`}
                    descriptionValue={oldDmrCodeData?.recordDescription}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder={`Enter ${typeName}`}
                              margin="dense"
                              name="code"
                              variant="outlined"
                              value={values?.code}
                              label={`${typeName}`}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              required
                              inputProps={{ maxLength: 25 }}
                              inputRef={codeRef}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                const value = currsorCodeIssue(codeRef);
                                setFieldValue('code', value);
                              }}
                              touched={touched.code}
                              error={Boolean(errors.code && touched.code)}
                              fullWidth
                            />
                            <FormHelperText style={{ color: 'red' }} variant="outlined">
                              {touched.code && errors.code}
                            </FormHelperText>
                          </Grid>

                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder={`Enter ${typeDesc}`}
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label={`${typeDesc}`}
                              inputProps={{ maxLength: 100 }}
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                setFieldValue('description', e.target.value);
                              }}
                              touched={touched.description}
                              required
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="d-flex justify-content-center  new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        disabled={enabledSubmission}
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {/* {isBasicInfoLoading && <PageLoader />} */}
    </>
  );
};

export default CopyDataManagerRecord;
